module.exports = __webpack_public_path__ + "static/media/branch-detail-1500.8d246e42.webp";